import React, { useState } from 'react';
import {
  View,
  ScrollView,
  StyleSheet,
  Dimensions,
  TouchableOpacity
} from 'react-native';
import {
  Text,
  Card,
  Title,
  Paragraph,
  Surface
} from 'react-native-paper';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Ionicons } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';

// Import calculator components
import MatchCalculatorComponent from '../components/calculators/MatchCalculatorComponent';
import CompareCalculatorComponent from '../components/calculators/CompareCalculatorComponent';
import UniversalYearComponent from '../components/calculators/UniversalYearComponent';
import PersonalYearComponent from '../components/calculators/PersonalYearComponent';
import PersonalMonthComponent from '../components/calculators/PersonalMonthComponent';

export default function CalculatorHubScreen({ navigation }) {
  const [selectedCalculator, setSelectedCalculator] = useState('match');
  
  const { width } = Dimensions.get('window');
  const isDesktop = width >= 1024;
  const isMobile = width < 768;

  const calculators = [
    { 
      id: 'match', 
      name: 'Match', 
      icon: 'heart', 
      color: '#E91E63',
      description: 'Find compatibility matches'
    },
    { 
      id: 'compare', 
      name: 'Compare', 
      icon: 'people', 
      color: '#3F51B5',
      description: 'Compare two people'
    },
    { 
      id: 'universalYear', 
      name: 'Universal Year', 
      icon: 'calendar', 
      color: '#2E7D32',
      description: 'Year energy insights'
    },
    { 
      id: 'personalYear', 
      name: 'Personal Year', 
      icon: 'person-circle', 
      color: '#E65100',
      description: 'Your yearly cycle'
    },
    { 
      id: 'personalMonth', 
      name: 'Personal Month', 
      icon: 'calendar-outline', 
      color: '#7B1FA2',
      description: 'Monthly insights'
    }
  ];

  // Render the selected calculator component
  const renderCalculator = () => {
    switch (selectedCalculator) {
      case 'match':
        return <MatchCalculatorComponent />;
      case 'compare':
        return <CompareCalculatorComponent />;
      case 'universalYear':
        return <UniversalYearComponent />;
      case 'personalYear':
        return <PersonalYearComponent />;
      case 'personalMonth':
        return <PersonalMonthComponent />;
      default:
        return <MatchCalculatorComponent />;
    }
  };

  return (
    <SafeAreaView style={styles.container}>
      <LinearGradient
        colors={['#667eea', '#764ba2']}
        style={styles.masterGradient}
      >

        {/* Calculator Menu */}
        <View style={styles.menuWrapper}>
          <ScrollView
            horizontal
            showsHorizontalScrollIndicator={false}
            style={styles.menuContainer}
            contentContainerStyle={styles.menuContent}
            centerContent={true}
          >
          {calculators.filter(calc => ['match', 'compare'].includes(calc.id)).map((calc) => (
            <TouchableOpacity
              key={calc.id}
              style={[
                styles.menuItem,
                selectedCalculator === calc.id && styles.menuItemActive
              ]}
              onPress={() => setSelectedCalculator(calc.id)}
            >
              <View style={[
                styles.menuIcon,
                { backgroundColor: selectedCalculator === calc.id ? 'rgba(255,255,255,0.4)' : 'rgba(255,255,255,0.2)' }
              ]}>
                <Ionicons 
                  name={calc.icon} 
                  size={24} 
                  color={calc.color} 
                />
              </View>
              <Text style={[
                styles.menuText,
                selectedCalculator === calc.id && styles.menuTextActive
              ]}>
                {calc.name}
              </Text>
              <Text style={styles.menuDescription}>
                {calc.description}
              </Text>
            </TouchableOpacity>
          ))}
          </ScrollView>
        </View>

        {/* Calculator Content */}
        <View style={styles.calculatorContent}>
          {renderCalculator()}
        </View>
      </LinearGradient>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  masterGradient: {
    flex: 1,
  },

  // Menu
  menuWrapper: {
    alignItems: 'center',
    marginBottom: 16,
    marginTop: 16,
  },
  menuContainer: {
    maxHeight: 120,
    flexGrow: 0,
  },
  menuContent: {
    paddingHorizontal: 16,
    gap: 12,
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '100%',
  },
  menuItem: {
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 16,
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    width: 140,
    height: 120,
    marginHorizontal: 4,
  },
  menuItemActive: {
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
  },
  menuIcon: {
    width: 48,
    height: 48,
    borderRadius: 24,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 8,
  },
  menuText: {
    fontSize: 12,
    color: 'rgba(255, 255, 255, 0.8)',
    textAlign: 'center',
    fontWeight: '600',
    marginBottom: 4,
  },
  menuTextActive: {
    color: '#ffffff',
    fontWeight: '700',
  },
  menuDescription: {
    fontSize: 10,
    color: 'rgba(255, 255, 255, 0.6)',
    textAlign: 'center',
    fontWeight: '400',
  },

  // Calculator Content
  calculatorContent: {
    flex: 1,
    backgroundColor: 'transparent',
  },
});